import { useCallback, useEffect, useState } from 'react';
const useAsync = (config) => {
    const { asyncFunction, autoLoad = undefined, initialState = undefined, successCallback = undefined, errorCallback = undefined, } = config;
    const [data, setData] = useState(initialState);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const execute = useCallback(async (...args) => {
        setIsLoading(true);
        setError(null);
        try {
            const response = await asyncFunction(...args);
            setData(response);
            if (successCallback) {
                successCallback(response);
            }
        }
        catch (errorResponse) {
            setError(errorResponse);
            if (errorCallback) {
                errorCallback(errorResponse);
            }
        }
        finally {
            setIsLoading(false);
        }
    }, [asyncFunction, successCallback, errorCallback]);
    useEffect(() => {
        if (autoLoad) {
            execute(...autoLoad);
        }
    }, []);
    return { execute, data, setData, isLoading, error };
};
export { useAsync };
//# sourceMappingURL=useAsync.js.map